function after() {
  this.$controllers.inputs.length = 0;
}

export {after};
